// import store from '../index'
import { bondType as type } from '@/helpers/enums';
import * as types from '../mutation-types';
import { unionState } from '../union-state'
const state = {
	filtered_simplified_bonds: [],
	simplified_accounting_bonds: [],
	simplified_cash_bonds: [],
	bond: {},
	not_posted_bonds: []
};

const actions = {
	fetchAll({ commit }, { bondType, subType }) {
		// const financial_file =
		// 	Object.keys(store.state.financialFiles).length > 0 
		// 	? store.state.financialFiles.current_financial_file
		// 	: null;
		return window.axios.get(`FundsFlow/Bonds/${bondType}`,{
			params:{
				// fromDate: financial_file ? new Date(financial_file.start_date).toISOString() : 'null',
				// toDate: financial_file ? new Date(financial_file.end_date).toISOString() : 'null',
				fromDate: null,
				toDate: null,
				subType
			}
		}
		).then(response => {
			if(bondType == type.accounting)
				commit(types.STORE_SIMPLIFIED_ACCOUNTING_BONDS, response.data);
			else if(bondType == type.cash)
				commit(types.STORE_SIMPLIFIED_CASH_BONDS, response.data);
			return response.data
		});
    },
    
	search({ commit }, { bondId, type, status, fromDate, toDate, dateSortMode, bondTypeSortMode}) {
		return window.axios.get(`FundsFlow/Bonds/Search`,{
			params:{
				bondId, type, status, fromDate, toDate, dateSortMode, bondTypeSortMode
			}
		}
		).then(response => {
				commit(types.STORE_FILTERED_SIMPLIFIED_BONDS, response.data);
			return response.data
		});
    },

	fetch({ commit }, { bondId, bondType }) {
		return window.axios.get(`FundsFlow/Bonds/${bondType}/${bondId}`).then(response => {
			commit(types.STORE_ONE_BOND, response.data);
			return response.data;
		});
	},
	fetchBondByNumber({ commit }, { bondType, bondNo }) {
		return window.axios.get(`FundsFlow/Bonds/${bondType}/ByNo/${bondNo}`).then(response => {
			commit(types.STORE_ONE_BOND, response.data);
			return response.data;
		});
	},

	create({ commit }, {bondType, date, subType, notes}) {
		return window.axios.post(`FundsFlow/Bonds/${bondType}`, {date, subType, notes}).then(response => {
			commit(types.STORE_ONE_BOND, response.data)
			if(bondType == type.accounting)
				commit(types.STORE_ONE_SIMPLIFIED_ACCOUNTING_BOND, response.data)
			else if(bondType == type.cash)
				commit(types.STORE_ONE_SIMPLIFIED_CASH_BOND, response.data)
			return response.data;
		});
	},
	update(_,{bondType, bondId, notes, date}) {
		return window.axios.put(`FundsFlow/Bonds/${bondType}/${bondId}`, { notes: notes, date: date})
	},
	updateToPosted(_, { bondId, bondType}) {
		return window.axios.put(`FundsFlow/Bonds/${bondType}/${bondId}/ChangeToPosted`, {}, {
			headers: {
				'Content-Type': 'application/json',
			}
		})
		// .then(response => {
		// 	if(bondType == type.accounting)
		// 		commit(types.STORE_ONE_SIMPLIFIED_ACCOUNTING_BOND, response.data)
		// 	else if(bondType == type.cash)
		// 		commit(types.STORE_ONE_SIMPLIFIED_CASH_BOND, response.data)
		// 	return response.data;
		// });
	},
	updateToNonPosted(_, { bondId, bondType}) {
		return window.axios.put(`FundsFlow/Bonds/${bondType}/${bondId}/ChangeToNotPosted`, {}, {
			headers: {
				'Content-Type': 'application/json',
			}
		})
		// .then(response => {
		// 	if(bondType == type.accounting)
		// 		commit(types.STORE_ONE_SIMPLIFIED_ACCOUNTING_BOND, response.data)
		// 	else if(bondType == type.cash)
		// 		commit(types.STORE_ONE_SIMPLIFIED_CASH_BOND, response.data)
		// 	return response.data;
		// });
	},

	updateEntry(_, { bondId, bondType, entry}) {
		delete entry.created_at
		delete entry.updated_at
		delete entry.deleted_at
		delete entry.is_cash
		delete entry.linked_entry_id
		delete entry.order_inside_bond
		return window.axios.put(`FundsFlow/Bonds/${bondType}/${bondId}/Entries/${entry.id}`, entry)
		.then(response => {
			// commit(types.STORE_ONE_BOND, response.data);
			return response.data;
		});
	},

	createEntry(_, { bondId, bondType, entry}) {
		delete entry.id
		return window.axios.post(`FundsFlow/Bonds/${bondType}/${bondId}/Entries`, entry)
		.then(response => {
			// commit(types.STORE_ONE_BOND, response.data);
			return response.data;
		});
	},

	deleteEntry(_, { bondId, bondType, entryId}) {
		return window.axios.delete(`FundsFlow/Bonds/${bondType}/${bondId}/Entries/${entryId}`).then(response => {
			// commit(types.DELETE_ONE_ENTRY, response.data);
			return response;
		});
	},
	delete({ commit }, { bondId, bondType }) {
		return window.axios.delete(`FundsFlow/Bonds/${bondType}/${bondId}`).then(response => {
			if(bondType == type.accounting)
				commit(types.DELETE_SIMPLIFIED_ACCOUNTING_BOND, response.data)

			else if(bondType == type.cash)
				commit(types.DELETE_SIMPLIFIED_CASH_BOND, response.data)

			commit(types.DELETE_SIMPLIFIED_BOND, response.data)
		});
	},
	fetchEntry({ commit }, { id }) {
		return window.axios.get(`FundsFlow/Entries/${id}`).then(response => {
			commit(types.STORE_ONE_ENTRY, response.data);
			return response.data;
		});
	},
	fetchNotPostedBonds({ commit }) {
		return window.axios.get('FundsFlow/Bonds/NotPosted').then(response => {
			commit(types.STORE_NOT_POSTED_BONDS, response.data);
			return response.data;
		});
	},

	// receipt or Payment 
	createEntryBond (_, { bondId, entry }) {
		return window.axios.post(`/FundsFlow/SubBonds/${bondId}/Entries`, entry).then((data) => {
			return data
		})
	},
	updateEntryBond(_, { bondId, entryId, entry  }) {
		return window.axios.put(`/FundsFlow/SubBonds/${bondId}/${entryId}/Entries`, entry).then((data) => {
			return data
		})
	},
	fetchByNo(_, { subBondNo, subBondType }) {
		return window.axios.get(`/FundsFlow/Bonds/BySubNo/${subBondNo}/${subBondType}`).then((data) => {
			return data
		})
	},
	// fetchEntriesBounds() {
	// 	return window.axios.get('')
	// }
	clearBond({commit}) {
		commit(types.CLEAR);
	}
};

const mutations = {
    [types.STORE_ONE_BOND](state, bond) {
		state.bond = bond;
	},

	[types.STORE_FILTERED_SIMPLIFIED_BONDS](state, simplified_bonds) {
		state.filtered_simplified_bonds = simplified_bonds;
	},
	[types.DELETE_SIMPLIFIED_BOND](state, simplified_bond) {
		state.filtered_simplified_bonds = unionState(state.filtered_simplified_bonds, [simplified_bond]);
	},

    [types.STORE_SIMPLIFIED_ACCOUNTING_BONDS](state, simplified_accounting_bonds) {
		state.simplified_accounting_bonds = simplified_accounting_bonds;
	},
	[types.STORE_ONE_SIMPLIFIED_ACCOUNTING_BOND](state, simplified_bond) {
		state.simplified_accounting_bonds = unionState(state.simplified_accounting_bonds, [simplified_bond]);
	},
	[types.DELETE_SIMPLIFIED_ACCOUNTING_BOND](state, simplified_bond) {
		state.simplified_accounting_bonds = unionState(state.simplified_accounting_bonds, [simplified_bond]);
	},

	[types.STORE_SIMPLIFIED_CASH_BONDS](state, simplified_cash_bonds) {
		state.simplified_cash_bonds = simplified_cash_bonds;
	},
	[types.STORE_ONE_SIMPLIFIED_CASH_BOND](state, simplified_bond) {
		state.simplified_cash_bonds = unionState(state.simplified_cash_bonds, [simplified_bond]);
	},
	[types.DELETE_SIMPLIFIED_CASH_BOND](state, simplified_bond) {
		state.simplified_cash_bonds = unionState(state.simplified_cash_bonds, [simplified_bond]);
	},
	[types.DELETE_ONE_ENTRY](state, id) {
		state.bond.entries = state.bond.entries.filter(v => v.id !== id)
	},
	[types.STORE_ONE_ENTRY](state, entry) {
		state.bond.entries = unionState(state.bond.entries, [entry]);
	},
	[types.STORE_NOT_POSTED_BONDS](state, not_posted_bonds) {
		state.not_posted_bonds = not_posted_bonds
	},
	[types.CLEAR] (state) {
		state.bond = {};
	}
};

const getters = {};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

